import { useEffect, useState } from 'react'
import checkMarketFlag from '../services/marketFlags'

export const FLAG_KEY = 'costentory-allow-inventory-refurb-adjustment'

export default function useRefurbishedAdjustmentFlag( branchId?: string | null ): boolean {
	const [ enabled, setEnabled ] = useState( false )

	useEffect( () => {
		let cancelled = false

		// Reset before the lookup: without this, `enabled` never returns to false once it flips,
		// so moving to a branch in a flag-off market (or to no branch at all) keeps the previous
		// branch's answer selectable.
		setEnabled( false )

		if ( branchId ) {
			checkMarketFlag( FLAG_KEY, branchId ).then( ( result ) => {
				if ( !cancelled ) {
					setEnabled( result )
				}
			} )
		}

		return () => {
			cancelled = true
		}
	}, [ branchId ] )

	return enabled
}
